var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:("hover-tips-" + _vm.position),style:(_vm.tipsStyle)},[_c('el-popover',{attrs:{"placement":"top-start","width":300,"trigger":"hover","popper-class":"popover_style","content":_vm.content,"transition":"zoom"}},[_c('span',{staticClass:"icon_info",attrs:{"slot":"reference"},slot:"reference"},[_vm._v("?")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f460911","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hoverTips/index.vue
// module id = null
// module chunks = 